<template>
  <li class="indicator">
    <h3 class="indicator__title">{{ title }}</h3>
    <p class="indicator__value">{{ valueFormatted }}</p>
  </li>
</template>

<script>
import { computed } from "vue";
import { formatNumber } from "@/modules/number";

export default {
  props: {
    title: {
      type: String,
      default: () => '',
    },
    value: {
      type: Number,
      default: () => 0,
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
  },
  setup(props) {
    const valueFormatted = computed(() => formatNumber(props.value));

    return {
      valueFormatted
    };
  },
};
</script>

<style lang="scss">
.indicator {
  width: 100%;
  min-width: 90px;
  max-width: 120px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.indicator__title {
  margin: 0;
  color: var(--secondary-blue-darker);
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 4px;
}

.indicator__value {
  margin: 0;
  font-size: 35px;
  line-height: 44px;
  font-weight: bold;
}
</style>
